<template>
  <ButtonBase
    theme="secondary"
    size="small"
    stroke="n"
    class="button"
    variant="outlined"
    rounded
    :to="url"
  >
    {{ $t('quiz.testYourself') }}
  </ButtonBase>
</template>

<script lang="ts" setup>
const route = useRoute();

const url = computed(() => {
  const { section, category } = route.params;
  return `/${section}/${route.params.lb_or_eval}/${category}/exercise/aleatoire`;
});
</script>
<style lang="scss" scoped>
.button {
  width: 100%;
}
</style>
